export const roundedUp = (num: number)=>{
   const convertToNumber = Number(num)
   return Number(new Intl.NumberFormat('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(convertToNumber))
}
